import propertyEpcApi from '../services/api/propertyEpcApi';
import { formatResponseErrorsForFormik } from '../services/http/errors';
import { setAlert } from './alerts';

export const RESET = 'EPC_LOOKUP/RESET';
export const LOOKUP_STATE_REFRESHED = 'EPC_LOOKUP/LOOKUP_STATE_REFRESHED';

export const lookupStateRefreshed = (showLookupSpinner, showLookupError) => ({
    type: LOOKUP_STATE_REFRESHED,
    showLookupSpinner,
    showLookupError,
});

export const reset = () => ({ type: RESET });

export const getEpcByProperty =
    (property, setFieldValue) => async (dispatch) => {
        try {
            dispatch(lookupStateRefreshed(true, false));

            const {
                data: { data: epc },
            } = await propertyEpcApi.lookupEpcByProperty(property.id);

            if (!epc) {
                dispatch(lookupStateRefreshed(false, true));
            } else {
                dispatch(lookupStateRefreshed(false, false));
                setFieldValue(
                    'current_energy_rating',
                    epc['current-energy-efficiency']
                );
                setFieldValue(
                    'potential_energy_rating',
                    epc['potential-energy-efficiency']
                );
                setFieldValue(
                    'environment_impact_current',
                    epc['environment-impact-current']
                );
                setFieldValue(
                    'environment_impact_potential',
                    epc['environment-impact-potential']
                );
            }
        } catch ({ response }) {
            dispatch(
                setAlert('EPC data unavailable.', 'error', 'property-details')
            );
        }
    };

export const createUpdateEpc =
    (values, { setSubmitting, setErrors, resetForm }, onSuccess) =>
    async (dispatch) => {
        try {
            if (values.id) {
                if (
                    !values.current_energy_rating &&
                    !values.potential_energy_rating &&
                    !values.environment_impact_current &&
                    !values.environment_impact_potential
                ) {
                    await propertyEpcApi.remove(values.id);
                } else {
                    await propertyEpcApi.update(values.id, values);
                }
            } else {
                await propertyEpcApi.create(values);
            }
            setSubmitting(false);
            resetForm();
            onSuccess();
            dispatch(setAlert('EPC updated.', 'success', 'property-details'));
        } catch ({ response }) {
            const formattedErrors = formatResponseErrorsForFormik(
                response.data.errors
            );
            setErrors(formattedErrors);
            setSubmitting(false);
        }
    };
